var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6405 1.1552C10.8601 0.935525 10.8601 0.57937 10.6405 0.3597C10.4208 0.14003 10.0646 0.14003 9.84497 0.3597L1.87362 8.33105C1.85176 8.23985 1.83367 8.13245 1.81964 8.00394C1.77646 7.60851 1.77792 7.0894 1.78129 6.33387L1.7896 4.47227C1.79098 4.16161 1.54027 3.90865 1.22961 3.90726C0.918956 3.90588 0.665995 4.15659 0.664609 4.46725L0.656153 6.3624C0.652956 7.07618 0.650343 7.65955 0.70129 8.12607C0.754268 8.61119 0.870944 9.04069 1.15697 9.41028C1.28238 9.57233 1.42783 9.71778 1.58989 9.8432C1.95947 10.1292 2.38897 10.2459 2.8741 10.2989C3.34061 10.3498 3.92398 10.3472 4.63775 10.344L6.53291 10.3356C6.84357 10.3342 7.09428 10.0812 7.0929 9.77055C7.09151 9.45989 6.83855 9.20918 6.5279 9.21057L4.66629 9.21887C3.91076 9.22224 3.39165 9.22371 2.99622 9.18052C2.86772 9.16649 2.76032 9.1484 2.66911 9.12655L10.6405 1.1552Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownLeft);
export default __webpack_public_path__ + "static/media/arrow-down-left.da507a1741a04617651cef8687f65f86.svg";
export { ForwardRef as ReactComponent };